// extracted by mini-css-extract-plugin
module.exports = {"topLink":"not-found-v2_component_topLink__l_bZN"};